export default __webpack_public_path__ + "static/media/mosaique.da7e1e4e.png";